
            const data = {"name":"chevron-right-1","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"m160 115 21-19 171 160-171 160-21-19 150-141z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    